export interface OrcamentoDataResponse {
  nomE_CLIENTE: string;
  nomE_VENDEDOR: string;
  data: string;
  dataupdate: string;
  datafaturamento: string;
  seQ_PEDIDO: number;
  vltotal: number;
  iD_VENDEDOR: number;
  status: number;
  substatus: number;
  iD_ORCAMENTO_FILIAL: number;
}

export interface EditarOrcamentoDataDisplayColumns {
  produtos: string;
  filial: number;
  qT_DISPONIVEL: number;
  desconto: number;
  valorUnitario: number;
  valorUnitarioComDesconto: number;
  quantidade: number;
  subTotal: number;
  unidade?: string;
  embalagem?: string;
  nomeEmbalagem?: string;
  eanEmbalagem?: string;
  obs: {
    observacao: string;
    ambiente: string;
  };
  remove: boolean;
  idProduto: number;
  ambiente?: string;
  retiradaImediata: boolean;
}

export interface TipoVendaDataDisplayColumns {
  produtos: string;
  qtd: number;
  qtdEntregue: number;
  qtdAEntregar: number;
  qtdSolicitada: number;
  orcamentoId?: number;
  index?: number;
  codprod?: number;
}

export interface TipoDeVendaItens {
  iD_PRODUTO: number;
  vltabela: number;
  vlproduto: number;
  percdesc: number;
  vldesc: number;
  nomeecommerce: string;
  embalagem: string;
  qt: number;
  qtentregue: number;
  qtdisp: number;
  orcamentoId?: number;
}

export interface TipoDeVendaItensWinthor {
  codigoProduto: number;
  descricao: string;
  embalagem: string;
  numeroPedido: number;
  quantidadeDevolucao: number;
  posicao: string;
  quantidade: number;
  quantidadeEntregue: number;
  tipoEstoque: string;
  tipoMercadoria: string;
}

export interface OrcamentoDataDisplayColumns {
  id: number;
  produtos: string;
  filial: number;
  desconto: string;
  valorUnitario: number;
  valorUnitarioComDesconto: number;
  quantidade: number;
  subTotal: string;
  unidade?: string;
  embalagem?: string;
  nomeEmbalagem?: string;
  observacao: {
    observacao?: string;
    ambiente?: string;
  };
}

export interface SearchProductDataDisplayColumns {
  image: string;
  produto: string;
  unidade: string;
  filial: number;
  preco: number;
  estoque: number;
  quantidade: number;
  embalagem?: string;
  nomeEmbalagem?: string;
  eanEmbalagem?: string;
  tipoEmbalagem?: ProdutoEmbalagem;
  embalagemOriginal?: string;
  embalagemSelecionada?: ProdutoEmbalagem;
  embalagens?: ProdutoEmbalagem[];
}

export interface ItemsDoOrcamentoDataDisplayColumns {
  produto: string;
  estoque: number;
  desconto: number;
  precoGerencia: number;
  preco: number;
  qtd: number;
  subTotal: number;
  checkboxDesconto: boolean;
  observation: string;
  remove: boolean;
}
export interface OrcamentoFilterRequest {
  iD_VENDEDOR?: null;
  iD_CLIENTE?: null;
  statusped?: number;
  substatusped?: null;
  seQ_PEDIDO?: null;
  orcamentO_FILIAL?: null;
  dataini?: null;
  datafim?: null;
  index: number;
  length: number;
}

export interface VendedoresResponse {
  nome_vendedor: string;
  id_vendedor: number;
}
export interface AllVendedoresResponse {
  nomE_VENDEDOR: string;
  idVendedor: number;
  tiposVenda?: string[];
  tipoVendaPadrao?: string | null;
}

export const STATUS_MAP: {
  [key: string]: number;
} = {
  'orçamento-criado'  :0,
  'integrado-com-erp' :1,
  'aguardando-integração-com-o-erp' :2,
  'pedido-gerado' :3,
  'integrado-com-erp-pedido' :4,
  'aguardando-integração-com-o-erp-pedido' :5,
  'aguardando-integração-do-winthor'  :6,
  'pendente' :7,
  'bloqueado' :8,
  'liberado' :9,
  'montado' :10,
  'faturado' :11,
  'cancelado' :12,
  'aguardando-liberação' :13,
  'rejeitado'  :14,
  'previsão-de-faturamento' :15,
  'devolução'  :16,
};

export const STATUS_ID_MAP: {
  [key: number]: string;
} = {
  0: 'ORÇAMENTO CRIADO',
  1: 'INTEGRADO COM ERP',
  2: 'AGUARDANDO INTEGRAÇÃO COM O ERP',
  3: 'PEDIDO GERADO',
  4: 'INTEGRADO COM ERP PEDIDO',
  5: 'AGUARDANDO INTEGRAÇÃO COM O ERP PEDIDO',
  6: 'AGUARDANDO INTEGRAÇÃO DO WINTHOR',
  7: 'PENDENTE',
  8: 'BLOQUEADO',
  9: 'LIBERADO',
  10: 'MONTADO',
  11: 'FATURADO',
  12: 'CANCELADO',
  13: 'AGUARDANDO LIBERAÇÃO',
  14: 'REJEITADO',
  15: 'PREVISÃO DE FATURAMENTO',
  16: 'DEVOLUÇÃO',
};

export const STATUS_TABLE_HEADEAR_COLOR: {
  [key: string]: string;
} = {
  'orçamento-criado'  : 'var(--pv-blue-02) !important',
  'integrado-com-erp' : 'var(--pv-green-02) !important',
  'aguardando-integração-com-o-erp' : 'var(--pv-orange) !important',
  'pedido-gerado' : 'var(--pv-green-02) !important',
  'integrado-com-erp-pedido' : 'var(--pv-green-02) !important',
  'aguardando-integração-com-o-erp-pedido' : 'var(--pv-orange) !important',
  'aguardando-integração-do-winthor'  : 'var(--pv-orange) !important',
  'pendente' : 'var(--pv-orange-01) !important',
  'bloqueado' : 'var(--pv-orange-01) !important',
  'liberado' : 'var(--pv-blue-02) !important',
  'montado' : 'var(--pv-blue-02) !important',
  'faturado' : 'var(--pv-green-02) !important',
  'cancelado' : 'var(--pv-red-01) !important',
  'aguardando-liberação' : 'var(--pv-orange) !important',
  'rejeitado'  : 'var(--pv-red-01) !important'
};
import { ProdutoEmbalagem } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/models/product.models';
